import { SidebarMenu } from '../../00-vue/SidebarMenu/SidebarMenu.js'
import { SidebarMenuItem } from '../../00-vue/SidebarMenu/SidebarMenuItem.js'

import { AccordionSelect } from '../../00-vue/AccordionSelect/AccordionSelect.js'

'use strict';

const { createApp } = Vue

const app = createApp({
  delimiters: ['[[', ']]'],
})

app.component('SidebarMenu', SidebarMenu)
app.component('SidebarMenuItem', SidebarMenuItem)
app.component('AccordionSelect', AccordionSelect)

if (!window.location.href.includes('/layout')) {
  app.mount('#sidebar')
}